import React, { useEffect } from 'react';
import BannersTable from './BannersTable';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Constants from '../../../Constants';
import { setNavigateToMsg } from '../../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../../actions/Page/PageAction';
const { formatDate } = Constants;

const BannerArchive = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle('Banner Message Archive'));
    dispatch(setNavigateToMsg('Banner Message Archive'));
  }, []);

  const pastBanners = useSelector((state) => state.Notifications.banners.past);

  return (
    <div tabIndex="-1" className={'banners-archive init-focus__hidden'}>
      <div id="bannerArchiveHeader" className="row">
        <div className="col-md-3">
          <div>
            <Link to="/messageUsers" className="anchor fontSm-15 lsn-primary-color" label="Back to Message Users">
              {' '}
              <i className="fal fa-arrow-left lsn-primary-color mRight-5" />
              Back to Message Users
            </Link>
          </div>
        </div>
        <div className="col-md-6">
          <h1 className="text-center" id="app_page_title">
            Banner Message Archive
          </h1>
        </div>
      </div>
      <div className="text-right fontSm-15">{pastBanners.length} Results Total</div>
      <BannersTable formatDate={formatDate} banners={pastBanners} isActiveBanners={false} />
    </div>
  );
};

export default BannerArchive;
